module.exports = __webpack_public_path__ + "img/camera-ia.a0a46b68.svg";